var map = {
	"./catalog": "./app/reducers/catalog.js",
	"./catalog.js": "./app/reducers/catalog.js",
	"./compatibility-chooser": "./app/reducers/compatibility-chooser.js",
	"./compatibility-chooser.js": "./app/reducers/compatibility-chooser.js",
	"./content": "./app/reducers/content.js",
	"./content.js": "./app/reducers/content.js",
	"./cookie": "./app/reducers/cookie.js",
	"./cookie.js": "./app/reducers/cookie.js",
	"./daily-updates": "./app/reducers/daily-updates.js",
	"./daily-updates.js": "./app/reducers/daily-updates.js",
	"./deck": "./app/reducers/deck.js",
	"./deck.js": "./app/reducers/deck.js",
	"./decks": "./app/reducers/decks.js",
	"./decks.js": "./app/reducers/decks.js",
	"./email-unsub": "./app/reducers/email-unsub.js",
	"./email-unsub.js": "./app/reducers/email-unsub.js",
	"./hexagram": "./app/reducers/hexagram.js",
	"./hexagram.js": "./app/reducers/hexagram.js",
	"./horoscope": "./app/reducers/horoscope.js",
	"./horoscope.js": "./app/reducers/horoscope.js",
	"./index": "./app/reducers/index.js",
	"./index.js": "./app/reducers/index.js",
	"./karmacoin-store": "./app/reducers/karmacoin-store.js",
	"./karmacoin-store.js": "./app/reducers/karmacoin-store.js",
	"./mail-lists": "./app/reducers/mail-lists.js",
	"./mail-lists.js": "./app/reducers/mail-lists.js",
	"./mobile-nav-dropdown": "./app/reducers/mobile-nav-dropdown.js",
	"./mobile-nav-dropdown.js": "./app/reducers/mobile-nav-dropdown.js",
	"./moon-phase": "./app/reducers/moon-phase.js",
	"./moon-phase.js": "./app/reducers/moon-phase.js",
	"./nav-bar-mobile": "./app/reducers/nav-bar-mobile.js",
	"./nav-bar-mobile.js": "./app/reducers/nav-bar-mobile.js",
	"./number": "./app/reducers/number.js",
	"./number.js": "./app/reducers/number.js",
	"./oranum": "./app/reducers/oranum.js",
	"./oranum.js": "./app/reducers/oranum.js",
	"./planet-tracker": "./app/reducers/planet-tracker.js",
	"./planet-tracker.js": "./app/reducers/planet-tracker.js",
	"./product": "./app/reducers/product.js",
	"./product-message": "./app/reducers/product-message.js",
	"./product-message.js": "./app/reducers/product-message.js",
	"./product.js": "./app/reducers/product.js",
	"./promo-message": "./app/reducers/promo-message.js",
	"./promo-message.js": "./app/reducers/promo-message.js",
	"./query-params": "./app/reducers/query-params.js",
	"./query-params.js": "./app/reducers/query-params.js",
	"./recaptcha": "./app/reducers/recaptcha.js",
	"./recaptcha.js": "./app/reducers/recaptcha.js",
	"./route": "./app/reducers/route.js",
	"./route.js": "./app/reducers/route.js",
	"./tarot-reading": "./app/reducers/tarot-reading.js",
	"./tarot-reading.js": "./app/reducers/tarot-reading.js",
	"./tcod": "./app/reducers/tcod.js",
	"./tcod.js": "./app/reducers/tcod.js",
	"./user": "./app/reducers/user.js",
	"./user.js": "./app/reducers/user.js",
	"./zodiac": "./app/reducers/zodiac.js",
	"./zodiac.js": "./app/reducers/zodiac.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



//////////////////
// WEBPACK FOOTER
// ./app/reducers ^\.\/.*$
// module id = 1
// module chunks = 0